export function buildQuestionnaireReviewPath(questionnaireId, docId) {
  const normalizedQuestionnaireId = encodeURIComponent(
    String(questionnaireId || "").trim(),
  );
  const normalizedDocId = encodeURIComponent(String(docId || "").trim());

  return `/questionnaires/${normalizedQuestionnaireId}/history/${normalizedDocId}`;
}
